import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../shared/material.module'
import { SharedModule } from '../../../shared/shared.module'
import { RebateClaimsHistoryComponent } from './rebate-claims-history.component'

@NgModule({
  declarations: [RebateClaimsHistoryComponent],
  imports: [CommonModule, RouterModule, UrlModule, SharedModule, MaterialModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        RebateClaimsHistoryComponent: {
          component: RebateClaimsHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class RebateClaimsHistoryModule {}
